// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-jsx": () => import("/home/chun/Development/workspace/invimarc/invimarc-web/src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-capture-jsx": () => import("/home/chun/Development/workspace/invimarc/invimarc-web/src/pages/capture.jsx" /* webpackChunkName: "component---src-pages-capture-jsx" */),
  "component---src-pages-index-jsx": () => import("/home/chun/Development/workspace/invimarc/invimarc-web/src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

